import React from 'react';
import { Button } from '@odin-labs/components';
import { ChangeType } from 'apollo/generated/client-operations';
import { getTempId } from 'utils';
import { ArrowLeftIcon, CheckIcon, PlusIcon } from 'components/icons';
import { Form } from 'components/form';
import {
  FormSubmissionWorkerEditFormProps,
  FormSubmissionWorkerFormData,
} from './types';
import {
  getDefaultValues,
  getFormInputs,
  getJobsiteWorkerOptions,
} from './FormSubmissionVisitorEditForm.forms';

export function FormSubmissionWorkerEditForm(
  props: FormSubmissionWorkerEditFormProps,
): React.ReactElement {
  const { jfsWorkerEdit, onCancel, onConfirm } = props;
  const formRef = React.useRef<HTMLFormElement>(null);
  const isAddition = jfsWorkerEdit.editType === 'create';

  const [isFormDirty, setIsFormDirty] = React.useState(false);

  const onSubmit = (data: FormSubmissionWorkerFormData): void => {
    onConfirm(
      {
        id: jfsWorkerEdit.id ?? getTempId(),
        jobsiteWorker: jfsWorkerEdit.jobsitesInfo.find(
          (j) => j.jobsiteWorkerId === data.jobsiteWorkerId.value,
        ).jobsiteWorker,
        changeType:
          jfsWorkerEdit.changeType ??
          (jfsWorkerEdit.editType === 'create'
            ? ChangeType.Created
            : ChangeType.Updated),
        extraData: { participantType: data.participantType.value },
        jobsitesInfo: jfsWorkerEdit.jobsitesInfo,
        associationType: jfsWorkerEdit.associationType,
      },
      jfsWorkerEdit.editType,
    );
  };

  const submitForm = React.useCallback((): void => {
    formRef.current.requestSubmit();
  }, [formRef.current]);

  const onIsDirtyChange = React.useCallback(
    (isDirty: boolean): void => setIsFormDirty(isDirty),
    [setIsFormDirty],
  );

  const jobsiteOptions = getJobsiteWorkerOptions(jfsWorkerEdit);
  const formInputs = getFormInputs(jfsWorkerEdit, jobsiteOptions);
  const defaultValues = getDefaultValues(jfsWorkerEdit, jobsiteOptions);

  return (
    <div>
      <Form
        ref={formRef}
        inputs={formInputs}
        onIsDirtyChange={onIsDirtyChange}
        onSubmit={onSubmit}
        defaultValues={defaultValues}
        inputsContainerClassName="odin-grid odin-grid-cols-6 odin-gap-6"
      />
      <div className="odin-flex odin-justify-between odin-mt-6">
        <div>
          {isAddition && (
            <Button
              icon={ArrowLeftIcon}
              text="Back"
              theme="naked"
              onClick={onCancel}
            />
          )}
        </div>
        <div>
          <Button
            icon={isAddition ? PlusIcon : CheckIcon}
            text={isAddition ? 'Add Worker' : 'Update Worker'}
            onClick={submitForm}
            disabled={!isFormDirty}
          />
        </div>
      </div>
    </div>
  );
}
